import * as React from 'react';
import { cn } from 'helpers/utils/classnames';
import EyeIcon from 'icons/eye-icon';
import { Button } from './button';
import { Input } from './input';

const PasswordInput = React.forwardRef<HTMLInputElement, Omit<React.ComponentProps<'input'>, 'type'>>(
  ({ className, ...props }, ref) => {
    const [isShowPassword, setShowPassword] = React.useState<boolean>(false);
    return (
      <div className="relative w-full">
        <Input
          ref={ref}
          {...props}
          type={isShowPassword ? 'text' : 'password'}
          className={cn('rounded-[3px] border border-black/20 px-3 py-2 pr-10', className)}
        />
        <Button
          aria-label={isShowPassword ? 'Hide password' : 'Show password'}
          aria-pressed={isShowPassword}
          type="button"
          className="absolute right-4 top-1/2 -translate-y-1/2"
          onClick={() => setShowPassword(!isShowPassword)}
        >
          <EyeIcon className={`${isShowPassword ? 'fill-[#4b5563]' : 'fill-[#7f7f7f]'} cursor-pointer text-lg`} />
        </Button>
      </div>
    );
  },
);
PasswordInput.displayName = 'Password Input';

export { PasswordInput };
